import { TextField } from '@mui/material';
import { TimePicker, TimePickerProps } from '@mui/x-date-pickers';
import * as React from 'react';
import { Control, Controller, UseFormRegisterReturn } from 'react-hook-form';
import { MuiPropsToOmit } from './dateAndTimeUtils';
import { fieldHighlightStyle } from './utils';

const format = 'HH:mm';

interface ImpactTimePickerProps extends Omit<TimePickerProps<any>, MuiPropsToOmit> {
    registerReturn: UseFormRegisterReturn;
    control: Control;
    label: string;
    disabled?: boolean;
    required?: boolean;
    highlighted?: boolean;
    minutesStep?: number;
}
export const ImpactTimePicker: React.FC<ImpactTimePickerProps> = (props) => {
    const { registerReturn, control, required, highlighted, minutesStep } = props;
    const { ref, ...registered } = registerReturn;

    return (
        <Controller
            control={control}
            {...registered}
            render={({ field: { ref: _, ...field }, fieldState }) => {
                return (
                    <TimePicker
                        //for MUI props
                        {...props}
                        {...field}
                        //otherwise optional empty fields will display as errors because
                        //they get passed new Date(undefined) -> Invalid Date
                        value={field.value ? new Date(field.value) : null}
                        format={format}
                        ampm={false}
                        timeSteps={{ minutes: minutesStep ?? 5 }}
                        slots={{
                            textField: TextField,
                        }}
                        slotProps={{
                            textField: {
                                size: 'small',
                                InputLabelProps: {
                                    shrink: true,
                                },
                                error: !!fieldState.error,
                                helperText: fieldState.error?.message || undefined,
                                fullWidth: true,
                                required,
                                name: field.name,
                                sx: highlighted ? fieldHighlightStyle : undefined,
                            },
                            field: {
                                clearable: true,
                            },
                        }}
                    />
                );
            }}
        />
    );
};
